import React from "react";
import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import "../styles/MapLocation.css";

const MapLocation = () => {
  return (
    <div className="map-location__section">
      <div className="map-location__header">
        <p className="map-location__subtitle">CONTACT US</p>
        <h2 className="map-location__title">Get In Touch</h2>
      </div>

      <div className="map-location__content-wrapper">
        <div className="map-location__map-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7492.303903225273!2d72.89806300860606!3d19.11854548014688!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c80a086f4ed3%3A0xbe314c31e73425f4!2sEvershine%20Sapphire%2C%20Mhada%20Colony%202%2C%20D%20P%20Road%20No%209%2C%20Chandivali%2C%20Mumbai%2C%20Maharashtra%2C%20India%2C%20DP%20Rd%20Number%209%2C%20MHADA%20Colony%2020%2C%20Powai%2C%20Mumbai%2C%20Maharashtra%20400072!5e0!3m2!1sen!2sin!4v1749814686927!5m2!1sen!2sin"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            title="Google Map"
            className="map-location__map-iframe"
          ></iframe>
        </div>

        <div className="map-location__details-card">
          <h3 className="map-location__details-title">Contact Details</h3>

          <div className="map-location__detail-item">
            <span className="map-location__detail-icon">
              <FaMapMarkerAlt />
            </span>
            <p className="map-location__detail-text">
              Evershine Sapphire, Above SBI Bank, DP Road 9, Chandivali, Powai,
              Mumbai - 400 072.
            </p>
          </div>
          <div className="map-location__detail-item">
            <span className="map-location__detail-icon">
              <FaEnvelope />
            </span>
            <div className="map-location__detail-link">
              <a href="mailto:sadanandgshetty185@gmail.com">
                sadanandgshetty185@gmail.com
              </a>
              <br />
              <a href="mailto:laxmihospitalityservicesind@gmail.com">
                laxmihospitalityservicesind@gmail.com
              </a>
            </div>
          </div>

          <div className="map-location__detail-item">
            <span className="map-location__detail-icon">
              <FaPhoneAlt />
            </span>
            <p className="map-location__detail-text">
              +91 97249 82104 <br />
              +91 99875 58691
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MapLocation;
